import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { FaUserAlt } from 'react-icons/fa';
import { fetchApi } from '../../services/api';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import TopPage from '../../components/TopPage';
import ListTestes from '../../components/ListTestes';
import Loading from '../../components/Loading';
import host from '../../services/host';
import ModalNovoTeste from '../../components/ModalNovoTeste';
import { getStorage } from '../../utils/storage';
import { getLink } from '../../services/host';
import ModalConfirm from '../../components/ModalConfirm';

class PerfilPaciente extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: props.match.params.id !== undefined ? props.match.params.id : null,
      nome: '',
      nascimento: '',
      idade: '',
      escolaridade: '',
      testes: [],
      ultimo: '',
      successMessages: [],
      errorMessages: [],
      isLoading: false,
      id_teste: null,
      teste_remoto: null,
      token: getStorage('token'),
    };

    this.novoTeste = this.novoTeste.bind(this);
  }

  componentDidMount() {
    document.title = `Perfil`;
    window.scrollTo(0, 0);

    if (this.state.id !== null) {
      this.carregarDados();
    }
  }

  carregarDados() {
    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(process.env.REACT_APP_PACIENTE_GET, this.state.id)
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState({
            nome: response.data.dados.nome,
            idade: response.data.idade,
            nascimento: response.data.dados.nascimento,
            escolaridade: response.data.dados.escolaridade,
            testes: response.data.testes,
            ultimo: response.data.ultimo,
          });
        } else {
          this.setState({
            id: null,
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          id: null,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  novoTeste(e) {
    e.preventDefault();

    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(process.env.REACT_APP_TESTE_NOVO, this.state.id)
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //mostra mensagem
          this.setState({
            id_teste: response.data.id_teste,
          });
        } else {
          this.setState({
            isLoading: false,
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  novoTesteRemoto(e, senha = false) {
    e.preventDefault();

    //ativa loading
    this.setState({
      isLoading: true,
      successMessages: [],
      errorMessages: [],
    });

    fetchApi
      .get(
        process.env.REACT_APP_TESTE_NOVO_REMOTO,
        this.state.id,
        senha ? '1' : '0',
      )
      .then((response) => {
        //esconde loading
        this.setState({
          isLoading: false,
        });

        if (response.data.status === 'success') {
          //atualiza listagem
          this.carregarDados();

          //mostra mensagem
          this.setState({
            teste_remoto: (
              <ModalNovoTeste
                onClick={(e) => {
                  this.setState({ teste_remoto: null });
                }}
                link={response.data.link_remote}
                pass={response.data.password}
              />
            ),
          });
        } else {
          this.setState({
            isLoading: false,
            errorMessages: response.data.messages,
          });
        }
      })
      .catch((err) => {
        //esconde loading
        this.setState({
          isLoading: false,
          errorMessages: [
            'Ocorreu um erro inexperado. Por favor, tente novamente.',
          ],
        });
      });
  }

  render() {
    return (
      <div>
        <Header />

        <div className="content">
          <TopPage
            title={this.state.nome}
            back={getLink(`/dashboard`)}
            small={`Data de nascimento: ${this.state.nascimento} - ${this.state.idade}`}
            small3={`Escolaridade: ${this.state.escolaridade}`}
            icon={true}
            editpaciente={getLink(`/editar-paciente/${this.state.id}`)}
            exportxls={`${host}/export-all/paciente/${this.state.id}?token=${getStorage('token')}`}
            addteste={(e) => {
              this.novoTeste(e);
            }}
            addtesteremoto={(e) => {
              this.novoTesteRemoto(e, false);
            }}
            addtesteremotosemsenha={(e) => {
              this.novoTesteRemoto(e, true);
            }}
          >
            <FaUserAlt />
          </TopPage>

          <ListTestes testes={this.state.testes} id_paciente={this.state.id} />
        </div>

        {this.state.id === null && <Redirect to={getLink(`/dashboard`)} />}

        {this.state.id_teste !== null && (
          <Redirect
            to={getLink(`/novo-teste/${this.state.id_teste}/modulo/1`)}
          />
        )}

        {this.state.teste_remoto !== null && this.state.teste_remoto}

        {this.state.errorMessages?.length > 0 ? (
          <ModalConfirm
            title="⚠️ Atenção"
            message={this.state.errorMessages.map((message, index) => {
              return (
                <div key={`error-message-` + index}>
                  {message === 'Crédito insuficiente'
                    ? 'Você não possui créditos suficientes para realizar o teste.'
                    : message}
                </div>
              );
            })}
            onClose={() => {
              this.setState({
                errorMessages: [],
              });
            }}
          />
        ) : null}

        <Footer />

        {this.state.isLoading ? <Loading /> : null}
      </div>
    );
  }
}

export default withRouter(PerfilPaciente);
